// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"305":"roadmap","594":"about","721":"tokenomics"}[chunkId] + "." + {"305":"a64c5630","594":"d2114063","721":"a5644128"}[chunkId] + ".js";
};